import { render } from "./Setting.vue?vue&type=template&id=41ad92db&scoped=true&ts=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"

import "./Setting.vue?vue&type=style&index=0&id=41ad92db&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ad92db"]])

export default __exports__